const NotHaveAccess = () => {
    return (
        <div className="rx-page-notfound">
            <div className="rx-page-inner-notfound">
            <h1>Thank you for using our pharmacy. At this time our location is not using the online intake feature. Please contact the store for assistance.</h1>
            </div>
        </div>
    );
}
export default NotHaveAccess